'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopUp = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _tzOffsets = require('tz-offsets');

var _tzOffsets2 = _interopRequireDefault(_tzOffsets);

var _cancellationTypes = require('constants/cancellation-types');

var _scheduleSource = require('constants/schedule-source');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopUp = exports.TopUp = function (_Component) {
  (0, _inherits3.default)(TopUp, _Component);

  function TopUp() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, TopUp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = TopUp.__proto__ || (0, _getPrototypeOf2.default)(TopUp)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      isDisabled: false
    }, _this2.handleReservationRequest = function () {
      var _this$props = _this.props,
          cost = _this$props.cost,
          credits = _this$props.credits,
          creditsNeeded = _this$props.creditsNeeded,
          currencyCode = _this$props.currencyCode,
          onReservationRequest = _this$props.onReservationRequest,
          page = _this$props.page,
          scheduleId = _this$props.scheduleId,
          venueId = _this$props.venueId;


      onReservationRequest(page, scheduleId, venueId, {
        credits: credits,
        override: 'purchase-top-up',
        purchase_price: {
          amount: cost,
          credits: creditsNeeded,
          currency: currencyCode
        }
      }, {
        top_up: true,
        top_up_price: cost,
        top_up_credit_amount: creditsNeeded
      });
    }, _this2.handleLateCancellationConfirmation = function () {
      _this.setState(function (prevState) {
        return { isDisabled: !prevState.isDisabled };
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(TopUp, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var lateCancellation = this.props.lateCancellation;

      this.setState({ isDisabled: lateCancellation === _cancellationTypes.CANCELLATION_LATE });
    }
  }, {
    key: 'renderCancellationPolicyLink',
    value: function renderCancellationPolicyLink() {
      return _react2.default.createElement(
        'a',
        { href: 'https://help.classpass.com/hc/articles/207942743-What-is-the-class-cancellation-policy-', target: '_blank', rel: 'noopener noreferrer' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'reservation.top-up.cancellation-policy.link',
          defaultMessage: 'fee'
        })
      );
    }
  }, {
    key: 'renderEndCycleDate',
    value: function renderEndCycleDate() {
      var _props = this.props,
          endOfCycleDate = _props.endOfCycleDate,
          msaTimeZone = _props.msaTimeZone;


      return _react2.default.createElement(_reactIntl.FormattedDate, {
        value: (0, _tzOffsets2.default)(endOfCycleDate, msaTimeZone) * 1000,
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
    }
  }, {
    key: 'renderLateCancellation',
    value: function renderLateCancellation() {
      var cancellationPolicy = this.props.cancellationPolicy;


      var cancellationMessage = cancellationPolicy === _cancellationTypes.CANCELLATION_FLYWHEEL ? _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.top-up.cancellation-policy.flywheel.late',
        defaultMessage: 'I understand that Flywheel/FlyBarre reservations must be canceled by 5pm the night before class, so canceling my reservation later will result in a {link}.',
        values: {
          link: this.renderCancellationPolicyLink()
        }
      }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.top-up.cancellation-policy.late',
        defaultMessage: 'I understand that this class starts within 12 hours, so canceling my reservation later will result in a {link}.',
        values: {
          link: this.renderCancellationPolicyLink()
        }
      });

      return _react2.default.createElement(
        'label',
        { className: 'reservation__cancellation-policy__late' },
        _react2.default.createElement('input', { type: 'checkbox', onChange: this.handleLateCancellationConfirmation }),
        _react2.default.createElement(
          'span',
          null,
          cancellationMessage,
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'reservation.top-up.non-refundable.late',
            defaultMessage: ' I also understand that credit purchases are non-refundable and must be used by {date}.',
            values: {
              date: this.renderEndCycleDate()
            }
          })
        )
      );
    }
  }, {
    key: 'renderEarlyCancellation',
    value: function renderEarlyCancellation() {
      var cancellationPolicy = this.props.cancellationPolicy;


      var cancellationMessage = cancellationPolicy === _cancellationTypes.CANCELLATION_FLYWHEEL ? _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.top-up.cancellation-policy.flywheel.early',
        defaultMessage: 'If you can\'t make class, please cancel Flywheel/FlyBarre reservations by 5pm the day before class to avoid a {link}.',
        values: {
          link: this.renderCancellationPolicyLink()
        }
      }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.top-up.cancellation-policy.early',
        defaultMessage: 'If you can\'t make class, please cancel your reservation at least 12 hours in advance to avoid a {link}.',
        values: {
          link: this.renderCancellationPolicyLink()
        }
      });

      return [cancellationMessage, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reservation.top-up.non-refundable',
        defaultMessage: ' Credit purchases are non-refundable and must be used by {date}.',
        values: {
          date: this.renderEndCycleDate()
        }
      })];
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          credits = _props2.credits,
          creditsBalance = _props2.creditsBalance,
          creditsNeeded = _props2.creditsNeeded,
          _props2$currencyCode = _props2.currencyCode,
          currencyCode = _props2$currencyCode === undefined ? 'USD' : _props2$currencyCode,
          endTime = _props2.endTime,
          includeTax = _props2.includeTax,
          lateCancellation = _props2.lateCancellation,
          klassName = _props2.klassName,
          cost = _props2.cost,
          source = _props2.source,
          startTime = _props2.startTime,
          timeZone = _props2.timeZone,
          venueName = _props2.venueName;
      var isDisabled = this.state.isDisabled;


      return _react2.default.createElement(
        'div',
        { className: 'reservation reservation--top-up' },
        _react2.default.createElement(
          'div',
          { className: 'reservation__header' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'reservation.top-up.header',
            defaultMessage: 'Buy {credits, plural, one {# more credit} other {# more credits}} to reserve this class',
            values: { credits: creditsNeeded },
            tagName: 'h2'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'reservation__class-name text--bold' },
          klassName
        ),
        _react2.default.createElement(_reactIntl.FormattedDate, {
          value: (0, _tzOffsets2.default)(startTime, timeZone) * 1000,
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        }),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'reservation.top-up.class.time',
          defaultMessage: '{start} - {end}',
          values: {
            start: _react2.default.createElement(_reactIntl.FormattedTime, {
              value: (0, _tzOffsets2.default)(startTime, timeZone) * 1000,
              hour: 'numeric',
              minute: 'numeric'
            }),
            end: _react2.default.createElement(_reactIntl.FormattedTime, {
              value: (0, _tzOffsets2.default)(endTime, timeZone) * 1000,
              hour: 'numeric',
              minute: 'numeric'
            })
          }
        }),
        _react2.default.createElement(
          'div',
          { className: 'reservation__venue pb' },
          venueName
        ),
        _react2.default.createElement(
          'span',
          { className: 'text--bold' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'reservation.top-up.credits.cost',
            defaultMessage: '{credits, plural, one {# credit} other {# credits}}',
            values: { credits: credits }
          })
        ),
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          id: 'reservation.top-up.credits.balance',
          defaultMessage: 'You have {credits, plural, one {# credit} other {# credits}}',
          values: { credits: creditsBalance }
        }),
        _react2.default.createElement(
          'div',
          { className: 'reservation__top-up-purchase mt' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'reservation.top-up.credits.buy',
            defaultMessage: 'Buy {credits, plural, one {# credit} other {# credits}}',
            values: { credits: creditsNeeded }
          }),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_reactIntl.FormattedNumber, {
              value: cost,
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }),
            includeTax && _react2.default.createElement(
              'span',
              null,
              ' ',
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'reservation.top-up.credits.tax',
                defaultMessage: ' + tax'
              })
            )
          )
        ),
        _react2.default.createElement(
          'button',
          {
            className: (0, _classnames2.default)('bt bt--primary bt--lg bt--width-full mt+ mb+', {
              'bt--disabled': isDisabled
            }),
            disabled: isDisabled,
            onClick: this.handleReservationRequest
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'reservation.top-up.reserve',
            defaultMessage: 'Purchase and reserve'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'reservation__cancellation-policy text--sm' },
          lateCancellation === _cancellationTypes.CANCELLATION_LATE ? this.renderLateCancellation() : this.renderEarlyCancellation()
        ),
        source === _scheduleSource.SCHEDULE_SOURCE_MINDBODY && _react2.default.createElement(
          'a',
          { className: 'reservation__mindbody mt', href: 'https://www.mindbodyonline.com/', target: '_blank', rel: 'noopener noreferrer' },
          _react2.default.createElement('img', { src: '/img/mindbody-powered-logo.png', alt: 'Powered by MindBody', width: '140', height: '43' })
        )
      );
    }
  }]);
  return TopUp;
}(_react.Component);

TopUp.propTypes = {
  cancellationPolicy: _propTypes2.default.string,
  credits: _propTypes2.default.number,
  creditsBalance: _propTypes2.default.number,
  creditsNeeded: _propTypes2.default.number,
  currencyCode: _propTypes2.default.string,
  endOfCycleDate: _propTypes2.default.number,
  endTime: _propTypes2.default.number,
  includeTax: _propTypes2.default.bool,
  lateCancellation: _propTypes2.default.string,
  onReservationRequest: _propTypes2.default.func,
  klassName: _propTypes2.default.string,
  cost: _propTypes2.default.number,
  msaTimeZone: _propTypes2.default.string,
  page: _propTypes2.default.string,
  scheduleId: _propTypes2.default.number,
  source: _propTypes2.default.string,
  startTime: _propTypes2.default.number,
  timeZone: _propTypes2.default.string,
  venueName: _propTypes2.default.string,
  venueId: _propTypes2.default.number
};